<template>
  <div class="knowledge-graph" @click="$emit('close')">
    <div class="wrap" ref="wrapRef" @click.stop>
      <div id="mountNode"></div>
    </div>

    <div class="close-btn">
      <svg viewBox="0 0 1024 1024" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em">
        <path
          d="M578.36284173 512l422.30899284-422.30899284c18.09895683-18.09895683 18.09895683-48.2638849 0-66.36284173-18.09895683-18.09895683-48.2638849-18.09895683-66.36284173 0l-422.30899284 422.30899284-422.30899284-422.30899284c-18.09895683-18.09895683-48.2638849-18.09895683-66.36284173 0-18.09895683 18.09895683-18.09895683 48.2638849 0 66.36284173l422.30899284 422.30899284-422.30899284 422.30899284c-18.09895683 18.09895683-18.09895683 48.2638849 0 66.36284173 18.09895683 18.09895683 48.2638849 18.09895683 66.36284173 0l422.30899284-422.30899284 422.30899284 422.30899284c18.09895683 18.09895683 48.2638849 18.09895683 66.36284173 0 18.09895683-18.09895683 18.09895683-48.2638849 0-66.36284173l-422.30899284-422.30899284z">
        </path>
      </svg>
    </div>

    <a-modal
      :width="380"
      v-model:visible="isOpenSearch"
      okText="搜索"
      cancelText="取消"
      title="搜索实体"
      @ok="searchNode()"
    >
      <div class="g6-editor-modal">
        <a-input placeholder="输入关键字" v-model:value="keywordForSearch" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import G6 from '@antv/g6'

const nodeLevelMap = [
  { lv: 1, size: 80 },
  { lv: 2, size: 70 },
  { lv: 3, size: 60 },
  { lv: 4, size: 55 },
  { lv: 5, size: 50 },
]

G6.registerNode('cnode', {
  setState(name, value, item) {
    if(name === 'highlight') {
      const group = item.getContainer()
      const shape = group.get('children')[0]
      const model = item.getModel()

      if(value) {
        shape.attr('stroke', '#e35f98')
        shape.attr('shadowColor', '#e35f98')
      }
      else {
        const color = model.color || '#fece4f'
        shape.attr('stroke', color)
        shape.attr('shadowColor', color)
      }
    }
  },
  draw(cfg, group) {
    const { label, style, img, size, color, level = 1 } = cfg

    const _size = size || nodeLevelMap[level - 1].size || 80
    const _color = color || '#fece4f'

    group.addShape('circle', {
      attrs: {
        x: 0,
        y: 0,
        r: _size / 2 - 5,
        fill: '#fff',
        stroke: _color,
        lineWidth: 2,
        shadowBlur: 4,
        shadowColor: _color,
        shadowOffsetX: style.shadowOffsetX || 0,
        shadowOffsetY: style.shadowOffsetY || 0,
      },
    })
    group.addShape('text', {
      attrs: {
        x: 0,
        y: _size / 2 + 8,
        text: label,
        textAlign: 'center',
        textBaseline: 'top',
        fill: '#fff',
      },
    })
    return group.addShape('image', {
      attrs: {
        x: -_size / 2 + 6,
        y: -_size / 2 + 6,
        width: _size - 12,
        height: _size - 12,
        img: img || '',
      },
      draggable: true,
    }).setClip({
      type: 'circle',
      attrs: {
        r: _size / 2 - 6,
      },
    })
  },
})

export default {
  name: 'knowledge-graph',
  props: {
    nodeIdMap: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      graph: null,
      isOpenSearch: false,
      keywordForSearch: '',
      renderConfigs: {
        autoLayout: true,
        gravity: 1.35,
      }
    }
  },
  computed: {
    ...mapState({
      currentClass: state => state.currentClass,
      userInfo: state => state.userInfo,
      knowledgeGraph: state => state.knowledgeGraph,
    }),
  },
  async mounted() {
    if (!this.knowledgeGraph) return

    let knowledgeGraph = JSON.parse(JSON.stringify(this.knowledgeGraph))
    if(knowledgeGraph.configs) this.renderConfigs = { ...this.renderConfigs, ...knowledgeGraph.configs }

    const ret = await this.$api.digitalbook.getWrongQuestionRecord({
      textbookId: this.currentClass.PK_ClassGuid,
      studentId: this.userInfo.PK_UserGuid,
    })
    if(ret && ret.data) {
      const colorMap = ['green', 'orange', 'blue', 'red']
      knowledgeGraph = {
        edges: knowledgeGraph.edges,
        nodes: knowledgeGraph.nodes.map(node => {
          const state = ret.data[node.label] || 2
          return {
            ...node,
            color: colorMap[state - 1] || 'orange',
          }
        }),
      }
    }

    const wrapRef = this.$refs.wrapRef
    const width = wrapRef.clientWidth
    const height = wrapRef.clientHeight

    const self = this

    const minimap = new G6.Minimap({
      className: 'g6-minimap',
      viewportClassName: 'g6-minimap-viewport'
    })
    const toolbar = new G6.ToolBar({
      position: { x: 20, y: 20 },
      getContent: () =>
        `<ul class='g6-component-toolbar'>
          <li code='zoomOut'>
            <svg class="icon" viewBox="0 0 1024 1024" fill="currentColor" width="1em" height="1em"><path d="M663.7037037 428.25955555H520.49540741V265.63318518c0-5.33997037-4.36906667-9.70903703-9.70903704-9.70903703h-72.81777778c-5.33997037 0-9.70903703 4.36906667-9.70903704 9.70903703v162.62637037H285.05125925c-5.33997037 0-9.70903703 4.36906667-9.70903703 9.70903704v72.81777778c0 5.33997037 4.36906667 9.70903703 9.70903703 9.70903704h143.2082963v162.62637037c0 5.33997037 4.36906667 9.70903703 9.70903704 9.70903704h72.81777778c5.33997037 0 9.70903703-4.36906667 9.70903704-9.70903704V520.49540741h143.20829629c5.33997037 0 9.70903703-4.36906667 9.70903705-9.70903704v-72.81777778c0-5.33997037-4.36906667-9.70903703-9.70903705-9.70903704z"></path><path d="M1008.37451852 942.83851852L831.18459259 765.64859259c148.18417778-180.70945185 137.86832592-448.43614815-31.55437037-617.73748148-179.61718518-179.73854815-471.37374815-179.73854815-651.71911111 0-179.73854815 180.34536297-179.73854815 472.10192592 0 651.71911111 169.30133333 169.4226963 437.02802963 179.73854815 617.73748148 31.55437037l177.18992593 177.18992593c3.88361482 3.39816297 10.07312592 3.39816297 13.34992593 0l52.18607407-52.18607407c3.39816297-3.2768 3.39816297-9.46631111 0-13.34992593zM735.30785185 735.30785185c-144.1792 144.05783703-377.68154075 144.05783703-521.86074074 0-144.05783703-144.1792-144.05783703-377.68154075 0-521.86074074 144.1792-144.05783703 377.68154075-144.05783703 521.86074074 0 144.05783703 144.1792 144.05783703 377.68154075 0 521.86074074z"></path></svg>
          </li>
          <li code='zoomIn'>
            <svg class="icon" viewBox="0 0 1024 1024" fill="currentColor" width="1em" height="1em"><path d="M663.7037037 428.25955555H285.05125925c-5.33997037 0-9.70903703 4.36906667-9.70903703 9.70903704v72.81777778c0 5.33997037 4.36906667 9.70903703 9.70903703 9.70903704h378.65244445c5.33997037 0 9.70903703-4.36906667 9.70903705-9.70903704v-72.81777778c0-5.33997037-4.36906667-9.70903703-9.70903705-9.70903704z"></path><path d="M1008.37451852 942.83851852L831.18459259 765.64859259c148.18417778-180.70945185 137.86832592-448.43614815-31.55437037-617.73748148-179.61718518-179.73854815-471.37374815-179.73854815-651.71911111 0-179.73854815 180.34536297-179.73854815 472.10192592 0 651.71911111 169.30133333 169.4226963 437.02802963 179.73854815 617.73748148 31.55437037l177.18992593 177.18992593c3.88361482 3.39816297 10.07312592 3.39816297 13.34992593 0l52.18607407-52.18607407c3.39816297-3.2768 3.39816297-9.46631111 0-13.34992593zM735.30785185 735.30785185c-144.1792 144.05783703-377.68154075 144.05783703-521.86074074 0-144.05783703-144.1792-144.05783703-377.68154075 0-521.86074074 144.1792-144.05783703 377.68154075-144.05783703 521.86074074 0 144.05783703 144.1792 144.05783703 377.68154075 0 521.86074074z"></path></svg>
          </li>
          <li code='realZoom'>
            <svg class="icon" viewBox="0 0 1024 1024" fill="currentColor" width="1em" height="1em"><path d="M288.99555555 694.04444445h68.26666667c5.00622222 0 9.10222222-4.096 9.10222223-9.10222223V339.05777778c0-5.00622222-4.096-9.10222222-9.10222223-9.10222223h-68.26666667c-5.00622222 0-9.10222222 4.096-9.10222222 9.10222223v345.88444444c0 5.00622222 4.096 9.10222222 9.10222222 9.10222223zM512 637.15555555c25.14488889 0 45.51111111-20.36622222 45.51111111-44.37333333 0-26.28266667-20.36622222-46.64888889-45.51111111-46.64888889s-45.51111111 20.36622222-45.51111111 46.64888889c0 24.00711111 20.36622222 44.37333333 45.51111111 44.37333333zM512 477.86666667c25.14488889 0 45.51111111-20.36622222 45.51111111-44.37333334 0-26.28266667-20.36622222-46.64888889-45.51111111-46.64888888s-45.51111111 20.36622222-45.51111111 46.64888888c0 24.00711111 20.36622222 44.37333333 45.51111111 44.37333334z"></path><path d="M930.70222222 56.88888889H93.29777778c-20.13866667 0-36.40888889 16.27022222-36.40888889 36.40888889v837.40444444c0 20.13866667 16.27022222 36.40888889 36.40888889 36.40888889h837.40444444c20.13866667 0 36.40888889-16.27022222 36.40888889-36.40888889V93.29777778c0-20.13866667-16.27022222-36.40888889-36.40888889-36.40888889z m-45.51111111 828.30222222H138.80888889V138.80888889h746.38222222v746.38222222z"></path><path d="M666.73777778 694.04444445h68.26666667c5.00622222 0 9.10222222-4.096 9.10222222-9.10222223V339.05777778c0-5.00622222-4.096-9.10222222-9.10222222-9.10222223h-68.26666667c-5.00622222 0-9.10222222 4.096-9.10222223 9.10222223v345.88444444c0 5.00622222 4.096 9.10222222 9.10222223 9.10222223z"></path></svg>
          </li>
          <li code='autoZoom'>
            <svg class="icon" viewBox="0 0 1024 1024" fill="currentColor" width="1em" height="1em"><path d="M330.66666667 59.73333333H93.86666667c-18.88 0-34.13333333 15.25333333-34.13333334 34.13333334v238.93333333c0 9.38666667 7.68 17.06666667 17.06666667 17.06666667h51.2c9.38666667 0 17.06666667-7.68 17.06666667-17.06666667V145.06666667h185.6c9.38666667 0 17.06666667-7.68 17.06666666-17.06666667v-51.2c0-9.38666667-7.68-17.06666667-17.06666666-17.06666667zM947.2 674.13333333h-51.2c-9.38666667 0-17.06666667 7.68-17.06666667 17.06666667v187.73333333H693.33333333c-9.38666667 0-17.06666667 7.68-17.06666666 17.06666667v51.2c0 9.38666667 7.68 17.06666667 17.06666666 17.06666667h236.8c18.88 0 34.13333333-15.25333333 34.13333334-34.13333334V691.2c0-9.38666667-7.68-17.06666667-17.06666667-17.06666667zM330.66666667 878.93333333H145.06666667V691.2c0-9.38666667-7.68-17.06666667-17.06666667-17.06666667h-51.2c-9.38666667 0-17.06666667 7.68-17.06666667 17.06666667v238.93333333c0 18.88 15.25333333 34.13333333 34.13333334 34.13333334h236.8c9.38666667 0 17.06666667-7.68 17.06666666-17.06666667v-51.2c0-9.38666667-7.68-17.06666667-17.06666666-17.06666667zM930.13333333 59.73333333H693.33333333c-9.38666667 0-17.06666667 7.68-17.06666666 17.06666667v51.2c0 9.38666667 7.68 17.06666667 17.06666666 17.06666667h185.6v187.73333333c0 9.38666667 7.68 17.06666667 17.06666667 17.06666667h51.2c9.38666667 0 17.06666667-7.68 17.06666667-17.06666667V93.86666667c0-18.88-15.25333333-34.13333333-34.13333334-34.13333334z"></path></svg>
          </li>
          <li code='search'>
            <svg class="icon" viewBox="0 0 1024 1024" fill="currentColor" width="1em" height="1em"><path d="M1017.88385589 947.7777179L687.45619648 617.35005851C738.73164769 551.06095164 766.46874037 470.01265783 766.46874037 384.7656298c0-102.04196489-39.82435787-197.72221128-111.83901139-269.86409917-72.01465352-72.1418879-167.94936865-111.8390114-269.86409918-111.83901139s-197.84944565 39.82435787-269.86409917 111.83901139C42.75964274 186.91618416 3.06251924 282.72366492 3.06251924 384.7656298c0 101.91473052 39.82435787 197.84944565 111.83901139 269.86409918C186.91618416 726.77161688 282.72366492 766.46874037 384.7656298 766.46874037c85.24702802 0 166.16808748-27.73709269 232.45719435-78.8853095l330.42765938 330.30042502c4.07149986 4.07149986 10.68768709 4.07149986 14.75918694 0l55.47418542-55.34695104c4.07149986-4.07149986 4.07149986-10.68768709 0-14.75918695zM586.30487219 586.30487219C532.35749924 640.12501077 460.85178318 669.77061903 384.7656298 669.77061903s-147.59186942-29.64560825-201.53924238-83.46574684C129.40624884 532.35749924 99.76064058 460.85178318 99.76064058 384.7656298s29.64560825-147.71910379 83.46574684-201.53924238C237.1737604 129.40624884 308.67947643 99.76064058 384.7656298 99.76064058s147.71910379 29.51837389 201.53924239 83.46574684S669.77061903 308.67947643 669.77061903 384.7656298s-29.64560825 147.71910379-83.46574684 201.53924239z"></path></svg>
          </li>
        </ul>`,
      handleClick: (code, graph) => {
        const animateCfg = { duration: 200, easing: 'easeCubic' }
        switch (code) {
          case 'zoomOut':
            graph.zoom(1.2, undefined, true, animateCfg)
            break
          case 'zoomIn':
            graph.zoom(0.8, undefined, true, animateCfg)
            break
          case 'realZoom':
            graph.zoomTo(1, undefined, true, animateCfg)
            break
          case 'autoZoom':
            graph.fitView(20, undefined, true, animateCfg)
            break
          case 'search':
            self.keywordForSearch = ''
            self.isOpenSearch = true
            break
          default:
            break
        }
      }
    })

    const { autoLayout, gravity } = this.renderConfigs
    const layout = autoLayout ? {
      type: 'fruchterman',
      gravity: this.device === 'phone' ? 0.3 : gravity,
      speed: 5,
      maxIteration: 1600,
      workerEnabled: true,
      gpuEnabled: true,
      tick: () => {
        graph.refreshPositions()
      },
    } : {
      preventOverlap: true,
      linkDistance: 200,
    }

    const graph = new G6.Graph({
      container: 'mountNode',
      width,
      height,
      plugins: [minimap, toolbar],
      modes: {
        default: [
          'drag-canvas',
          'zoom-canvas',
          'drag-node',
        ],
      },
      layout,
      animate: true,
      defaultNode: {
        type: 'cnode',
      },
      defaultEdge: {
        style: {
          stroke: '#ddd',
          lineWidth: 2,
          endArrow: {
            path: 'M 0,0 L 8,4 L 8,-4 Z',
            fill: '#fff',
          },
        },
        labelCfg: {
          autoRotate: true,
          style: {
            fill: '#333',
            fontSize: 12,
            background: {
              fill: '#fff',
              padding: [5, 6, 5, 6],
              radius: 10,
            },
          }
        },
      },
      edgeStateStyles: {
        click: {
          stroke: '#e35f98',
          lineWidth: 3,
        },
      },
    })
    this.graph = graph

    graph.data(knowledgeGraph)
    graph.get('canvas').set('localRefresh', false)
    graph.render()

    const mapInductionIdList = this.nodeIdMap.map(item => item.inductionId)
    graph.on('afterlayout', () => {
      const handleClick = evt => {
        const node = evt.item
        const { model } = node._cfg
        const [inductionId, id] = model.bind.replace('textbook://', '').split('#')

        let targetInductionId = inductionId
        if (!mapInductionIdList.includes(inductionId)) {
          const targetInduction = this.nodeIdMap.find(item => item.idList.includes(id))
          if (targetInduction) targetInductionId = targetInduction.inductionId
          this.$emit('clickGraphNode', { inductionId: targetInductionId, id })
        }
      }
      graph.on('node:click', handleClick)
      graph.on('node:touchstart', handleClick)

      graph.on('canvas:click', () => {
        const highlightNodes = graph.findAllByState('node', 'highlight')
        highlightNodes.forEach(cn => {
          graph.setItemState(cn, 'highlight', false)
        })
      })
    })
  },
  methods: {
    searchNode() {
      if(!this.keywordForSearch) return

      const findNode = this.graph.find('node', node => {
        const label = node.getModel().label
        return label.indexOf(this.keywordForSearch) !== -1
      })
      if(findNode) {
        this.graph.focusItem(findNode)
        this.graph.setItemState(findNode, 'highlight', true)
        this.isOpenSearch = false
      }
      else {
        this.$message.warning('搜索不到相关节点')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.knowledge-graph {
  position: fixed;
  inset: 0;
  z-index: 999;
  background-color: rgba($color: #000, $alpha: .2);
}

.wrap {
  position: absolute;
  inset: 30px;
  border-radius: 12px;
  box-shadow: 0 0 20px #ccc;
  background-color: rgba($color: #000, $alpha: .95);
  overflow: hidden;
}

.close-btn {
  width: 80px;
  height: 80px;
  background-color: rgba(0, 0, 0, .6);
  border-radius: 50%;
  position: fixed;
  right: -40px;
  top: -40px;
  z-index: 999;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, .75);
  }

  svg {
    position: absolute;
    bottom: 18px;
    left: 18px;
    font-size: 13px;
    color: #fff;
  }
}
</style>

<style lang="scss">
.g6-minimap {
  position: absolute;
  right: 20px;
  bottom: 20px;
  box-shadow: 0 0 30px rgba(0, 0, 0, .15);
  border-radius: 10px;
  background-color: rgba($color: #111, $alpha: .8);
  border: 2px solid #fff;
}

.g6-minimap-viewport {
  outline: #e86b99 solid 2px !important;
}

.g6-component-toolbar {
  li {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;

    .icon {
      font-size: 20px;
      color: #333;
      opacity: 1;
    }

    &:hover {
      background-color: #f5f5f5;
    }

    &+li {
      margin-left: 6px;
    }
  }
}
</style>